import { createAction, createSlice, } from "@reduxjs/toolkit";
import { nowISO } from "../../utils";

const initialState = {
    timer: 150,
    timerStarted: false,
    endTime: 0,
    endedAt: null,
    showResult: false,
    showTimerModal: false
};

export const quizTimerSlice = createSlice({
	name: "timer",
	initialState,
	reducers: {
        setTimer(state, action) {
            state.timer = action.payload;
        },
        setTimerStarted(state, action) {
            state.timerStarted = action.payload;
        },
        setEndTime(state, action) {
            state.endTime = action.payload;
            state.endedAt = nowISO();
        },
        setShowResultModal(state, action) {
            state.showResult = action.payload;
        },
        setShowTimerModal(state, action) {
            state.showTimerModal = action.payload;
        }
	},
});

export const quizTimerActions = {
    setTimer: quizTimerSlice.actions.setTimer,
    setTimerStarted: quizTimerSlice.actions.setTimerStarted,
    setEndTime: quizTimerSlice.actions.setEndTime,
    setShowResultModal: quizTimerSlice.actions.setShowResultModal,
    setShowTimerModal: quizTimerSlice.actions.setShowTimerModal,
};

export const getTimer = state => state.timer.timer;
export const getTimerStarted = state => state.timer.timerStarted;
export const getEndTime = state => state.timer.endTime;
export const getEndedAt = state => state.timer.endedAt;
export const getShowResult = state => state.timer.showResult;
export const getShowTimerModal = state => state.timer.showTimerModal;

export default quizTimerSlice.reducer;
